import { Button, Typography } from "@material-ui/core";
import clsx from "clsx";
import { pluralize } from "helpers/pluralize";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "store/StoreConfigs";
import { eventDecisionStyles } from "./EventDecisionStyles";

export default observer(function EventDecision() {
    const classes = eventDecisionStyles();
    const { thorEventViewStore, identityStore } = useStore();

    const isDecisions = thorEventViewStore.eventDetails.impactedBatches.some((x) => x.details.decision === "Pending");

    const numbers = thorEventViewStore.eventDetails.impactedBatches.filter((x) => x.details.decision === "Pending");
    return (
        <div className={classes.main}>
            {numbers.length > 0 && (
                <Typography className={classes.errorText}>
                    The following batch {pluralize("number", numbers.length)} require Impact Decisions to close this
                    event:{" "}
                    {numbers.map((x, index) => (
                        <span key={x.batchId}>
                            #{x.batchNumber} {index + 1 !== numbers.length && ", "}
                        </span>
                    ))}
                </Typography>
            )}
            <Button
                disabled={isDecisions}
                className={clsx(classes.pdfBtn, classes.btn, {
                    [classes.disablePdfBtn]: isDecisions,
                })}
                onClick={() => {
                    thorEventViewStore.exportEventPDF({
                        customerId: identityStore.currentCustomerId,
                        eventId: thorEventViewStore.eventDetails.eventId,
                    });
                }}
            >
                <Typography>Export to PDF</Typography>
            </Button>
        </div>
    );
});
